import * as React from 'react';
import clsx from 'clsx';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateField } from '@mui/x-date-pickers';
import { InputAdornment } from '@mui/material';

import { IVerificationResultByRecognition } from 'common/ui/interfaces/verification-result-by-recognition';
import { VerificationResultByRecognition } from 'common/ui/constants/verification-result-by-recognition';
import { StatusTooltipTemplate } from '../Tooltip/template';
import { StatusTooltip } from '../Tooltip';

import { ReactComponent as CheckmarkIcon } from 'assets/images/input-checkmark.svg';
import { ReactComponent as WarningIcon } from 'assets/images/warning.svg';

import styles from './styles.module.scss';

type InputProps = {
  verified?: boolean;
  format?: string;
  label: string;
  value: any;
  verificationResult?: IVerificationResultByRecognition;
  onChange: (v: any) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  disabled?: boolean;
  hideVerification?: boolean;
  required?: boolean;
};

export const DatePickerWithStatus = ({
  label,
  verified,
  format = 'MM/dd/yyyy',
  value,
  verificationResult = VerificationResultByRecognition,
  onChange,
  disabled,
  hideVerification = false,
  onMouseEnter,
  onMouseLeave,
  required = false,
}: InputProps) => {
  let inputValue = value || undefined;

  if (!inputValue || isNaN(new Date(inputValue).getTime())) {
    inputValue = undefined;
  }

  if (inputValue && !(inputValue instanceof Date)) {
    inputValue = new Date(inputValue);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateField
        required={required}
        className={clsx(
          styles.root,
          !verified && styles.unverified,
          verified && styles.verified
        )}
        label={label}
        value={inputValue}
        onChange={onChange}
        format={format}
        InputProps={{
          endAdornment: hideVerification ? undefined : (
            <InputAdornment position="end">
              {verified ? (
                <CheckmarkIcon />
              ) : (
                <StatusTooltip
                  title={
                    <StatusTooltipTemplate
                      title={verificationResult.title}
                      text={verificationResult.text}
                    />
                  }
                >
                  <WarningIcon />
                </StatusTooltip>
              )}
            </InputAdornment>
          ),
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};
